import React from 'react'
import { GridCell } from './GridCell'
import _ from 'common-tools/LodashHelper'

export function Col (props) {
  const { hide, children, layout = { sm: 12, md: 9, lg: 6 }, className } = props

  if (hide === true) {
    return null
  }
  if (_.isObject(layout)) {
    const p = {
      small: 0,
      smallOffSet: 0,
      medium: 0,
      mediumOffSet: 0,
      large: 0,
      largeOffSet: 0
    }
    if (_.isObject(layout.sm)) {
      p.small = layout.sm.size
      p.smallOffSet = layout.sm.offset
    } else {
      p.small = layout.sm
    }
    if (_.isObject(layout.md)) {
      p.medium = layout.md.size
      p.mediumOffSet = layout.md.offset
    } else {
      p.medium = layout.md
    }
    if (_.isObject(layout.lg)) {
      p.large = layout.lg.size
      p.largeOffSet = layout.lg.offset
    } else {
      p.large = layout.lg
    }
    return <GridCell {...p} className={className}>{children}</GridCell>
  } else if (layout === 'auto') {
    return <GridCell auto className={className}>{children}</GridCell>
  } else if (layout === 'shrink') {
    return <GridCell shrink className={className}>{children}</GridCell>
  } else {
    return <GridCell small={12} medium={9} large={6} className={className}>{children}</GridCell>
  }
}
